import { DataCoreFlowstep, SimEngineFlowStep } from "types/Flowstep/Flowstep.interface";
import { SystemError, BusinessError } from "./constants";
import { DataTableShape } from "cubee2e-cube-global-components/dist/src/types";

export const refEmail: string = "cvocapp";
export const refPassword: string = "Password#@24";

export const dataTableHeaders: DataTableShape.ColumnData[] = [
  // {
  //   field: "sNo",
  //   name: "No.",
  //   width: 110,
  //   resizable: false,
  //   fixed: true,
  //   type: "number",
  //   pinned: true,
  //   copyIcon: false,
  //   headerAlign: "center",
  //   valueAlign: "center",
  // },
  {
    field: "urn",
    name: "URN",
    width: 160,
    resizable: true,
    fixed: true,
    type: "string",
    pinned: true,
    copyIcon: true,
    headerAlign: "center",
    valueAlign: "center",
    sortable: false,
  },
  {
    field: "soldOrderNumber",
    name: "Sold Order Number",
    width: 170,
    resizable: true,
    fixed: false,
    type: "string",
    pinned: false,
    copyIcon: true,
    headerAlign: "center",
    valueAlign: "center",
    sortable: false,
  },
  {
    field: "dealerCode",
    name: "Dealer Code",
    width: 160,
    resizable: true,
    fixed: false,
    type: "string",
    pinned: false,
    copyIcon: true,
    headerAlign: "center",
    valueAlign: "center",
    sortable: false,
  },
  {
    field: "plantsourcecode",
    name: "Plant Code",
    width: 180,
    resizable: true,
    fixed: false,
    type: "string",
    pinned: false,
    copyIcon: true,
    headerAlign: "center",
    valueAlign: "center",
    sortable: false,
  },
  {
    field: "salesseriesname",
    name: "Sales Series",
    width: 180,
    resizable: true,
    fixed: false,
    type: "string",
    pinned: false,
    copyIcon: true,
    headerAlign: "center",
    valueAlign: "center",
    sortable: false,
  },
  {
    field: "time",
    name: "Date - Time (CST)",
    width: 160,
    resizable: true,
    fixed: false,
    type: "string",
    pinned: false,
    copyIcon: false,
    headerAlign: "center",
    valueAlign: "center",
    sortable: false,
  },
  {
    field: "status",
    name: "Status",
    width: 160,
    resizable: true,
    fixed: false,
    type: "string",
    pinned: false,
    headerAlign: "center",
    valueAlign: "center",
    sortable: false,
  },
  {
    field: "NsoIcon",
    name: "NSO - SIM Engine",
    width: 150,
    sortable: false,
    resizable: true,
    fixed: true,
    hide: false,
    type: "string",
    pinned: false,
    headerAlign: "center",
    valueAlign: "center",
  },
  {
    field: "SIMIcon",
    name: "SIM Engine - VOC",
    resizable: true,
    fixed: true,
    type: "boolean",
    pinned: false,
    width: 150,
    headerAlign: "center",
    valueAlign: "center",
    sortable: false,
  },
];

export const DataCoreFlowsteps: DataCoreFlowstep[] = [
  {
    id: 1,
    stepId: 1,
    name: "Start",
    status: "Completed",
    enabled: true,
    requestData: {},
    responseData: {},
    color: "#fff",
  },
  {
    id: 2,
    stepId: 2,
    name: "Process DataCore",
    status: "Completed",
    enabled: true,
    requestData: {},
    responseData: {},
    color: "#fff",
    errorId: [3, 11, 14, 15],
    errorType: SystemError,
  },
  {
    id: 3,
    stepId: 0,
    name: "Check DataCore Status",
    status: "Completed",
    enabled: true,
    requestData: {},
    responseData: {},
    color: "#fff",
    errorType: BusinessError,
  },
  {
    id: 4,
    stepId: 3,
    name: "Process VA",
    status: "Completed",
    enabled: true,
    requestData: {},
    responseData: {},
    color: "#fff",
    errorId: [5, 11, 14, 15],
    errorType: SystemError,
  },
  {
    id: 5,
    stepId: 0,
    name: "Check VA Status",
    status: "Completed",
    enabled: true,
    requestData: {},
    responseData: {},
    color: "#fff",
    errorType: BusinessError,
  },
  {
    id: 6,
    stepId: 4,
    name: "Process TOMS",
    status: "Completed",
    enabled: true,
    requestData: {},
    responseData: {},
    color: "#fff",
    errorId: [12, 14, 15],
    errorType: SystemError,
  },
  {
    id: 7,
    stepId: 0,
    name: "Check TOMS Status",
    status: "Completed",
    enabled: true,
    requestData: {},
    responseData: {},
    color: "#fff",
    errorType: BusinessError,
  },
  {
    id: 8,
    stepId: 6,
    name: "Update NonBuildableSpec",
    status: "Completed",
    enabled: true,
    requestData: {},
    responseData: {},
    color: "#fff",
    errorId: [12, 14, 15],
    errorType: SystemError,
  },
  {
    id: 9,
    stepId: 7,
    name: "ILA Fetch",
    status: "Completed",
    enabled: true,
    requestData: {},
    responseData: {},
    color: "#fff",
    errorId: [12, 14, 15],
    errorType: SystemError,
  },
  {
    id: 10,
    stepId: 9,
    name: "SIM Engine POST",
    status: "Completed",
    enabled: true,
    requestData: {},
    responseData: {},
    color: "#fff",
    errorId: [12, 14, 15],
    successId: [13, 15],
    errorType: SystemError,
  },
  {
    id: 11,
    stepId: 0,
    name: "Business Error Handler",
    status: "Completed",
    enabled: true,
    requestData: {},
    responseData: {},
    color: "#fff",
  },
  {
    id: 12,
    stepId: 0,
    name: "System Error Handler",
    status: "Completed",
    enabled: true,
    requestData: {},
    responseData: {},
    color: "#fff",
  },
  {
    id: 13,
    stepId: 0,
    name: "End Flow",
    status: "Completed",
    enabled: true,
    requestData: {},
    responseData: {},
    color: "#fff",
  },
  {
    id: 14,
    stepId: 0,
    name: "Error Flow",
    status: "Completed",
    enabled: true,
    requestData: {},
    responseData: {},
    color: "#fff",
  },
  {
    id: 15,
    stepId: 0,
    name: "End",
    status: "Completed",
    enabled: true,
    requestData: {},
    responseData: {},
    color: "#fff",
  },
];

// interface DataCoreFlowDefinition {
//     NSO_Request: { stepId: string },
//     Get_Vehicle_Data: { stepId: string },
//     Get_Spec_From_Toms: { stepId: string },
//     Update_Non_Buildable_Spec: { stepId: string },
//     Get_Inline_Accessory_From_Pcps: { stepId: string },
//     Post_Order_Change_to_SimEngine: { stepId: string },
// }

export const dataCoreFlowDefinition: {
  [key: string]: { stepId: string };
} = {
  NSO_Request: { stepId: "1" },
  Get_Vehicle_Data: { stepId: "2" },
  checkVehicleElgibility: { stepId: "3" },
  Get_Spec_From_Toms: { stepId: "4" },
  Update_Non_Buildable_Spec: { stepId: "6" },
  Get_Inline_Accessory_From_Pcps: { stepId: "7" },
  Post_Order_Change_to_SimEngine: { stepId: "9" },
};

export const simEngineFlowDefinition: {
  [key: string]: { stepId: string };
} = {
  Order_Change_Response_from_SimEngine: { stepId: "9" },
  Post_Order_Change_Response_to_NSO: { stepId: "14" },
  Generate_Check_Digit: { stepId: "5" },
  Get_Vehicle_Pricing: { stepId: "10" },
  Publish_Updates_to_Vehicle_Hub: { stepId: "11" },
  Publish_Legacy_Backfill: { stepId: "12" },
  Error_Flow: { stepId: "0" },
};
export const SimEngineFlowsteps: SimEngineFlowStep[] = [
  {
    id: 1,
    stepId: 9,
    name: "Order Change Response from SimEngine",
    status: "Completed",
    enabled: true,
    requestData: {},
    responseData: {},
    color: "#fff",
  },
  {
    id: 2,
    stepId: 0,
    name: "Check Sim Engine Status",
    status: "Completed",
    enabled: true,
    requestData: {},
    responseData: {},
    color: "#fff",
  },
  {
    id: 3,
    stepId: 14,
    name: "NSO Response",
    status: "Completed",
    enabled: true,
    requestData: {},
    responseData: {},
    color: "#fff",
  },
  {
    id: 4,
    stepId: 10,
    name: "Get Pricing",
    enabled: true,
    requestData: {},
    responseData: {},
    color: "#fff",
  },
  {
    id: 5,
    stepId: 5,
    name: "Generate Check Digit",
    status: "Completed",
    enabled: true,
    requestData: {},
    responseData: {},
    color: "#fff",
  },
  {
    id: 6,
    stepId: 11,
    name: "Publish Datacore",
    status: "Completed",
    enabled: true,
    requestData: {},
    responseData: {},
    color: "#fff",
    errorId: [5, 11, 14, 15],
    errorType: SystemError,
  },
  {
    id: 7,
    stepId: 12,
    name: "NVS BackFill",
    status: "Completed",
    enabled: true,
    requestData: {},
    responseData: {},
    color: "#fff",
  },
  {
    id: 8,
    stepId: 0,
    name: SystemError,
    status: "Completed",
    enabled: true,
    requestData: {},
    responseData: {},
    color: "#fff",
  },
  {
    id: 9,
    stepId: 0,
    name: BusinessError,
    status: "Completed",
    enabled: true,
    requestData: {},
    responseData: {},
    color: "#fff",
  },
  {
    id: 10,
    stepId: 0,
    name: "End flow",
    status: "Completed",
    enabled: true,
    requestData: {},
    responseData: {},
    color: "#fff",
  },
  {
    id: 11,
    stepId: 0,
    name: "Error flow",
    status: "Completed",
    enabled: true,
    requestData: {},
    responseData: {},
    color: "#fff",
  },
  {
    id: 12,
    stepId: 0,
    name: "End",
    status: "Completed",
    enabled: true,
    requestData: {},
    responseData: {},
    color: "#fff",
  },
  {
    id: 13,
    stepId: 13,
    name: "Publish RTO",
    status: "Completed",
    enabled: true,
    requestData: {},
    responseData: {},
    color: "#fff",
    errorId: [5, 11, 14, 15],
    errorType: SystemError,
  },
];

// export interface SimEngineFlowDefinition {
//     Order_Change_Response_from_SimEngine: { stepId: string };
//     Post_Order_Change_Response_to_NSO: { stepId: string };
//     Get_Vehicle_Pricing: { stepId: string };
//     Publish_Updates_to_Vehicle_Hub: { stepId: string };
//     Publish_Legacy_Backfill: { stepId: string };
// }
